import { useEffect } from 'react'
import log from './log'
import { TrackGtmEvents } from './trackEvents'
import { useInitializeGTM } from './useInitializeGTM'

export const variableName = 'dataLayer'

export const DataLayerProvider = ({ ENV }: { ENV: Record<string, string> }) => {
  const containerId = ENV?.GTM_CONTAINER_ID as string
  const source = ENV?.GTM_SOURCE

  const gtmjsFired = useInitializeGTM(containerId)

  useEffect(() => {
    window[variableName] = window[variableName] || []
    TrackGtmEvents(
      (args: Record<any, any>) => {
        push({ ...args, source: ENV?.GTM_SOURCE })
      },
      { variableName },
    )
  }, [])

  useEffect(() => {
    if (gtmjsFired) {
      push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
        source,
      })
    }
  }, [gtmjsFired, source])

  const push = (...args: any) => {
    window[variableName]?.push(...args)
    try {
      log.json(args)
    } catch (e) {
      log.json({ erro: JSON.stringify(e) })
    }
  }

  return <>{/* React Datalayer mounted */}</>
}
